import { Button } from "@ai-teach/ui-web";
import { useNavigate } from "@tanstack/react-router";
import { HiRefresh } from "react-icons/hi";

interface NotFoundProps {
  title?: string;
  description?: string;
  // Allow any additional props (e.g. NotFoundRouteProps from TanStack Router)
  [key: string]: unknown;
}

export function NotFound({
  title = "Page not found",
  description = "The page you're looking for doesn't exist or has been moved.",
}: NotFoundProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="text-center space-y-4">
        <p className="text-7xl font-bold text-primary-600">404</p>
        <h2 className="h2">{title}</h2>
        <p className="body text-secondary-200">{description}</p>
        <div className="flex justify-center gap-3 pt-2">
          <Button variant="primary" onClick={() => window.location.reload()}>
            Try Again
          </Button>
          <Button variant="secondary" onClick={() => window.history.back()}>
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
